import axios from 'axios';

const BASE_URL = import.meta.env.VITE_API_BASE_URL;

export async function assignShift(substoreId, fromDate, toDate) {
  await new Promise((resolve) => setTimeout(resolve, 300));
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Token ${token}` } : {})
  };
  const payload = {
    substore_id: substoreId,
    from_date: fromDate,
    to_date: toDate
  };
  const response = await axios.post(`${BASE_URL}/core/schedule/`, payload, { headers });
  return response.data;
}

export async function getSchedule(substoreId, fromDate, toDate) {
  await new Promise((resolve) => setTimeout(resolve, 300));
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Token ${token}` } : {})
  };
  const params = {
    substore_id: substoreId,
    from_date: fromDate,
    to_date: toDate
  };
  const response = await axios.get(`${BASE_URL}/core/view-schedule/`, { headers, params });
  return response.data;
}

export async function createLeaveRequest({ employeeId, startDate, endDate, reason }) {
  await new Promise((resolve) => setTimeout(resolve, 200));
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Token ${token}` } : {})
  };
  const payload = { employee: employeeId, start_date: startDate, end_date: endDate, reason };
  const response = await axios.post(`${BASE_URL}/core/owner/leaves/`, payload, { headers });
  return response.data;
}

export async function createSwapRequest({ shiftId, requesterId, targetEmployeeId, reason }) {
  await new Promise((resolve) => setTimeout(resolve, 200));
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Token ${token}` } : {})
  };
  const payload = { shift: shiftId, requester: requesterId, target_employee: targetEmployeeId, reason };
  const response = await axios.post(`${BASE_URL}/core/owner/swaps/`, payload, { headers });
  return response.data;
}

export async function getSwapShiftRequests(employeeId) {
  await new Promise((resolve) => setTimeout(resolve, 300));
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Token ${token}` } : {})
  };
  try {
    const response = await axios.get(`${BASE_URL}/core/owner/swaps/`, { headers, params: { requester__id: employeeId } });
    return response.data;
  } catch (error) {
    console.error('Error fetching swap shift requests:', error);
    throw error;
  }
}